import type { DurationUnits } from "@heraion/shared";
import type { TFn } from "./i18nTypes";

/** The hour / minute words of a duration label ("1 h 05 min"), translated.
 *  Hand it to `formatMinutesLabel` / `formatDurationLabel` in @heraion/shared. */
export const durationUnits = (t: TFn): DurationUnits => ({
  hour: t("mobile.timeline.hourShort", { defaultValue: "h" }),
  minute: t("mobile.timeline.minShort", { defaultValue: "min" }),
});
